/**
 * Generated by orval v8.14.0 🍺
 * Do not edit manually.
 * Realico Portal API
 * Portal API
 * OpenAPI spec version: 1.0.0
 */

export type ListingResponseDtoVisibilityStatus = typeof ListingResponseDtoVisibilityStatus[keyof typeof ListingResponseDtoVisibilityStatus];


export const ListingResponseDtoVisibilityStatus = {
  DRAFT: 'DRAFT',
  PUBLISHED: 'PUBLISHED',
  HIDDEN: 'HIDDEN',
  ARCHIVED: 'ARCHIVED',
} as const;
